<template>
  <div class="public-information-block">
    <div class="banner">
      <div class="container-block">
        <div class="info">
          <h1>{{ $route.query.from ? '我的资料(已购)' : '公益音频' }}</h1>
          <p>科研圈内人--让科研人员专注于科学本身！</p>
          <p>INSIDER OF SCIENCE</p>
          <p>丰富的服务内容，新颖的服务方式，</p>
          <p>专业的服务团队，优惠的服务价格。</p>
        </div>
        <div class="order">
          <img src="@/assets/imgs/icon2.png" />
          <p>订单累计：{{ total }}</p>
        </div>
      </div>
    </div>

    <Breadcrumb />

    <div class="container-block">
      <div class="card-block">
        <div class="title">
          <img src="@/assets/imgs/icon3.png" />
          <span>{{ $route.query.from ? '我的资料(已购)' : '公益音频' }}</span>
          <el-button
            @click="toList"
            type="primary"
            plain
            icon="el-icon-refresh-left"
            size="mini"
            >返回音频列表</el-button
          >
        </div>

        <el-alert
          v-if="!isLogin"
          :closable="false"
          show-icon
          title="友情提示 Important Notice"
          type="warning"
        >
          <div class="flex">
            <span
              >为更好地为您提供服务，请首先进行注册/登录，本系统仅登录用户方可观看相关音频资料，建议您先注册/登录再进行相关音频资料收听。</span
            >
            <span @click="toLogin" class="tel">立即登录 Login</span>
          </div>
        </el-alert>

        <audio :src="audio.link" controls="controls" controlsList="nodownload">
          您的浏览器不支持 audio 标签。
        </audio>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * @description 公益音频
 */
import * as api from '@/api/user'
import * as commonFunc from '@/utils/common-func'
import Breadcrumb from '@/components/Breadcrumb'

export default {
  name: 'AudioDetail',
  components: {
    Breadcrumb
  },
  data() {
    return {
      total: 0, // 订单总量
      audio: {
        name: '',
        link: ''
      },
      isLogin: true // true已登陆
    }
  },
  created() {
    this.getOrderTotal() //获取订单总数

    if (
      !localStorage.getItem('userInfo') ||
      localStorage.getItem('userInfo') == 'null'
    ) {
      this.isLogin = false
    }

    this.audio.name = this.$route.query.name
    this.audio.link = commonFunc.decrypt(this.$route.query.link)

    // 没登录的话，直接返回上一层
    if (
      !localStorage.getItem('userInfo') ||
      localStorage.getItem('userInfo') == 'null'
    ) {
      // this.$router.go(-1);//返回上一层
      this.toList()
    }

    // 某些视频需要积分达到一定数量才能观看
    const _is_need_point = this.$route.query.is_need_point
    const _need_point = this.$route.query.need_point
    const _point = parseFloat(
      JSON.parse(localStorage.getItem('userInfo')).point
    )
    if (_is_need_point == 1 && _need_point > _point) {
      this.$message.error(
        '积分不足，当前音频需要至少' + _need_point + '积分才能允许收听！'
      )
      // this.$router.go(-1);//返回上一层
      this.toList()
    }
  },
  mounted() {
    document.addEventListener('contextmenu', function (e) {
      e.preventDefault()
    })
  },
  methods: {
    /**
     * @description 返回列表
     */
    toList() {
      const _this = this
      if (_this.$route.query.from == 'activity') {
        _this.$router.push({
          path: `/order`,
          query: {
            activeName: _this.$route.query.from
              ? _this.$route.query.from
              : 'video'
          }
        })
      } else {
        _this.$router.push({
          path: `/public-information`,
          query: {
            activeName: _this.$route.query.from
              ? _this.$route.query.from
              : 'video'
          }
        })
      }
    },

    /**
     * @description 获取订单总数
     */
    getOrderTotal() {
      const _this = this
      const _param = {}
      api
        .orderTotal(_param)
        .then((res) => {
          const _data = res.data

          _this.total = _data.order_total || 0
        })
        .catch((err) => {
          console.log(err)
          // _this.$message.error('操作失败，请稍后刷新页面再试！')
        })
    },

    /**
     * @description 点击去登录
     */
    toLogin() {
      this.$store.dispatch('user/toLogin', { toggle: true })
    }
  }
}
</script>
<style lang="scss" scoped>
.public-information-block {
  .banner {
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url('../../assets/imgs/banner1.png');
    height: 336px;
    color: #ffffff;

    p {
      font-size: 18px;
    }

    .container-block {
      height: 336px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .info {
      color: #ffffff;
      margin-left: 60px;

      h1 {
        font-size: 38px;
      }
    }

    .order {
      margin-right: 220px;
    }
  }

  .card-block {
    // width: 100%;
    padding: 20px;
    margin: 20px 0 0 0;
    background: #ffffff;
    border: 1px solid #dfdfdf;
    -moz-box-shadow: 15px 15px 0 #dddddd; /* 老的 Firefox */
    box-shadow: 15px 15px 0 #dddddd;

    .title {
      display: flex;
      align-items: center;
      font-size: 24px;
      padding: 0 20px 20px 20px;
      border-bottom: 1px solid #dcdfe6;

      img {
        display: block;
        width: 30px;
        margin: 0 10px 0 0;
      }

      > span {
        flex-grow: 1;
      }
    }

    audio {
      width: 100%;
      margin: 30px 0 0 0;
    }

    audio:focus {
      outline: none;
    }
  }

  /deep/.el-alert {
    margin: 0 0 15px 0;
    .el-alert__content {
      width: 100%;
    }

    .el-alert__title {
      font-size: 16px;
    }

    .flex {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
    }

    .tel {
      cursor: pointer;
      display: inline-block;
      width: 180px;
      height: 36px;
      line-height: 36px;
      border-radius: 3px;
      text-align: center;
      color: #ffffff;
      background: #ea870f;
      margin-top: -20px;
    }
  }
}
</style>